var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalmartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "141px",
    height: "141px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#8c3e7c",
    stroke: "#8c3e7c",
    strokeWidth: 3.8880000000000003,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#8c3e7c;stroke-linecap:round;stroke-linejoin:round;}")), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 24,
    y1: 15.42,
    x2: 24,
    y2: 4.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 31.41,
    y1: 19.7,
    x2: 40.87,
    y2: 14.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 31.41,
    y1: 28.26,
    x2: 40.87,
    y2: 33.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 24,
    y1: 32.58,
    x2: 24,
    y2: 43.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 16.59,
    y1: 28.26,
    x2: 7.13,
    y2: 33.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 16.59,
    y1: 19.7,
    x2: 7.13,
    y2: 14.24
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalmartIcon);
export default __webpack_public_path__ + "static/media/walmartIcon.ae6b894abfb6c34c4d2a99b735c93854.svg";
export { ForwardRef as ReactComponent };